export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<> \/])[\sA-Za-z\d!@#$%^&*(),.?":{}|<> \/]{8,}$/;

export const nameRegex = /^[a-zA-Z ]+$/;

export const alphanumericRegex = /^[a-z\d\-_\s]+$/i;

export const numericRegex = /^[0-9]*$/;

export const numericFrom0To100 = /^(?:100|\d{1,2})$/;

export const numericFrom1To12 = /^(1[0-2]|[1-9])$/;

export const numericRegexValueAtLeast1 = /^[1-9][0-9]*$/;